var runtime = require("../../../../../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"button":"_3ERdo"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._3ERdo{border:0;padding:0;background:none;outline:none;touch-action:manipulation;cursor:pointer;white-space:nowrap;user-select:none}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

